"use client";
import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';
import * as React from 'react';
import { Box } from '../../Box/Box.web.js';
import { ContentText } from '../../ContentText/ContentText.web.js';
import { NPSButton } from '../NPSButton/NPSButton.web.js';
import { useTheme } from '../../utils/theming/useTheme.js';
import { spacing } from '../../constants/spacing.js';
import { px2rem } from '../../utils/helpers/style.js';

var ScorePage = function ScorePage(_ref) {
  var minScore = _ref.minScore,
    maxScore = _ref.maxScore,
    score = _ref.score,
    setScore = _ref.setScore,
    labels = _ref.labels,
    color = _ref.color;
  var numItems = maxScore - minScore + 1;
  var scores = _toConsumableArray(Array(numItems)).map(function (_, index) {
    return index + minScore;
  });
  var theme = useTheme();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ContentText, {
    pb: spacing.s,
    "data-testid": "elemental-NPS-ScorePage-Description",
    color: theme.nps.web.textColors.description
  }, labels.npsDescription), /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    maxWidth: px2rem(40 * numItems)
  }, /*#__PURE__*/React.createElement(Box, {
    backgroundColor: theme.nps.web.scoreOptionsBackground,
    padding: px2rem(2),
    flexWrap: "nowrap",
    display: "flex"
  }, scores.map(function (buttonScore) {
    return /*#__PURE__*/React.createElement(NPSButton, {
      key: buttonScore,
      score: score,
      buttonScore: buttonScore,
      onClick: setScore,
      color: color
    });
  })), /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    justifyContent: "space-between",
    pt: spacing.xxs
  }, /*#__PURE__*/React.createElement(ContentText, {
    color: theme.nps.web.textColors.scoreMinMax,
    size: "xs",
    weight: "light",
    "data-testid": "elemental-NPS-ScorePage-minScore"
  }, labels.minScore), /*#__PURE__*/React.createElement(ContentText, {
    color: theme.nps.web.textColors.scoreMinMax,
    size: "xs",
    weight: "light",
    "data-testid": "elemental-NPS-ScorePage-maxScore"
  }, labels.maxScore))));
};

export { ScorePage };
